var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.902 7.21l-1.976-5.929C17.672.516 16.957 0 16.148 0h-5.523v7.5h9.324c-.015-.098-.015-.195-.047-.29zM9.375 0H3.852c-.809 0-1.524.516-1.778 1.281L.098 7.211c-.032.094-.032.191-.047.289h9.324V0zM0 8.75v9.375C0 19.16.84 20 1.875 20h16.25C19.16 20 20 19.16 20 18.125V8.75H0z",
    transform: "translate(2 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.94c4b47622c3c446175c6b3a889ddbdf.svg";
export { ForwardRef as ReactComponent };